module.exports = __webpack_public_path__ + "static/media/IMG_2332.9772b025.jpg";